/// <reference types="@welldone-software/why-did-you-render" />

import { ErrorBoundary } from '@ecomm/error-handling'
import { useFooterQuery } from '@ecomm/footer-data'
import React, { Suspense } from 'react'
import { Footer } from './Footer'

type Props = {
  readonly footerId: string
  readonly type?: 'Full' | 'Slim'
  readonly showCountrySelector?: boolean
}

function FooterContent({ footerId, type, showCountrySelector = true }: Props) {
  const footer = useFooterQuery(footerId)
  return (
    <Footer
      {...footer}
      showCountrySelector={showCountrySelector}
      type={type ?? footer.type}
    />
  )
}

/**
 * For use in Gatsby only!
 *
 * Fetches footer data from Contentful and renders the Footer component wrapped in Suspense.
 */
export const GatsbyFooter = React.memo(function GatsbyFooter(props: Props) {
  return (
    <Suspense>
      <ErrorBoundary>
        <FooterContent {...props} />
      </ErrorBoundary>
    </Suspense>
  )
})

GatsbyFooter.whyDidYouRender = true
